"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Vue, Component, PropSync } from "vue-property-decorator";
let ItemElementMeta = class extends Vue {
  // get version() {
  //   const [_os,_arch] = this._osName.split("x");
  //   const version = _os.replace("win", "").toLocaleUpperCase();
  //   return version
  // }
  get checkStatus() {
    if (this._item.status !== "open" || this._item.shops.length === 0) {
      return true;
    }
    return false;
  }
};
__decorateClass([
  PropSync("item")
], ItemElementMeta.prototype, "_item", 2);
ItemElementMeta = __decorateClass([
  Component({})
], ItemElementMeta);
export {
  ItemElementMeta as default
};
